<template>
  <div id="waitImmediateEffect">
    <disclosure
      v-if="executingPlot.id == 7"
      v-on:send-effect="showEffect"
      v-on:proceed-mission="proceedState"
      v-on:execute-action="sendRequest"
      :is-executer="isExecuter"
      :executer="executer"
    />
    <responsibility
      v-if="executingPlot.id == 5"
      v-on:send-effect="showEffect"
      v-on:proceed-mission="proceedState"
      v-on:execute-action="sendRequest"
      :is-executer="isExecuter"
      :executer="executer"
    />
    <eavesdrop
      v-if="executingPlot.id == 6"
      v-on:send-effect="showEffect"
      v-on:proceed-mission="proceedState"
      v-on:execute-action="sendRequest"
      :is-executer="isExecuter"
      :executer="executer"
    />
  </div>
</template>

<script>
import disclosure from '@/components/gameComponents/waitImmediateEffectComponents/Disclosure.vue'
import responsibility from '@/components/gameComponents/waitImmediateEffectComponents/Responsibility.vue'
import eavesdrop from '@/components/gameComponents/waitImmediateEffectComponents/Eavesdrop.vue'
export default {
  name: "waitImmediateEffect",
  components: {
    disclosure,
    responsibility,
    eavesdrop,
  },
  plops: [],
  data() {
    return {
      roomId: this.$store.state.gameInfo.roomId,
      userId: this.$store.state.userInfo.id,
      leader: this.$store.getters.leader,
      socket: this.$store.state.webSocket.socket,
      users: this.$store.state.userList.users,
      isAssigned: [],
      executerIndex: 0,
    };
  },
  computed: {
    round () {
      return this.$store.state.missionInfo.round
    },
    isLeader: function() {
      return true
      // return this.$store.getters.isLeader;
    },
    plotList () {
      return this.$store.state.userList.plotList
    },
    getExecuterIndex () {
      return this.executerIndex
    },
    executer () {
      var leaderIndex = 0;
      for (var i=0; i<this.users.length; i++){
        if(this.users[i].isLeader){
          leaderIndex = i;
          break
        }
      }
      var executer = []
      for (i=0; i<this.users.length; i++){
        // プレイヤごとの処理
        // if(this.users[(leaderIndex+i)%this.users.length].plots.find(plot => plot.id == 6 && !plot.done)){
        //   executer.push(this.users[(leaderIndex+i)%this.users.length])
        // }
        // カードごとの処理
        for (var j=0; j<this.users[(leaderIndex+i)%this.users.length].plots.filter(plot => (plot.id == 5 || plot.id == 6 || plot.id == 7) && !plot.done).length; j++){
          executer.push(this.users[(leaderIndex+i)%this.users.length])
        }
      }
      return executer.length > 0 ? executer[0] : null
    },
    executingPlot () {
      var leaderIndex = 0;
      for (var i=0; i<this.users.length; i++){
        if(this.users[i].isLeader){
          leaderIndex = i;
          break
        }
      }
      var remainingPlot = []
      var filteredPlots = []
      for (i=0; i<this.users.length; i++){
        // カードごとの処理
        filteredPlots = this.users[(leaderIndex+i)%this.users.length].plots.filter(plot => (plot.id == 5 || plot.id == 6 || plot.id == 7) && !plot.done)
        for (var j=0; j<filteredPlots.length; j++){
          remainingPlot.push(filteredPlots[j])
        }
      }

      console.log("executing plot:" + remainingPlot)
      return remainingPlot.length > 0 ? remainingPlot[0] : null
    },
    hasDisclosure () {
      for (var i=0; i<this.users.length; i++){
        for (var j=0; j<this.users[i].plots.length; j++){
          if (this.users[i].plots[j].id == 7 && !this.users[i].plots[j].done){
            return true
          }
        }
      }
      return false
    },
    hasResponsibility () {
      for (var i=0; i<this.users.length; i++){
        for (var j=0; j<this.users[i].plots.length; j++){
          if (this.users[i].plots[j].id == 5 && !this.users[i].plots[j].done){
            return true
          }
        }
      }
      return false
    },
    hasEavesdrop () {
      for (var i=0; i<this.users.length; i++){
        for (var j=0; j<this.users[i].plots.length; j++){
          if (this.users[i].plots[j].id == 6 && !this.users[i].plots[j].done){
            return true
          }
        }
      }
      return false
    },
    isExecuter () {
      return this.executer.id == this.userId
      // if (this.executer.id == this.userId){
      //   return true
      // }else {
      //   return false
      // }
    }
  },
  methods: {
    assign(num) {
      if (this.isAssigned[num]){
        this.$set(this.isAssigned, num, false)
      }else {
        for (var i=0; i<this.users.length; i++){
          this.$set(this.isAssigned, i, false)
        }
        this.$set(this.isAssigned, num, true)
      }
    },
    showEffect: function(id){
      var plot = this.$store.getters.getPlotEffect(id);
      console.log(plot)
      var modalContent = {title: plot.name, text: plot.effect}
      this.$emit('send-modal', modalContent)
    },
    sendRequest: function(jsonRequest) {
      this.$emit("send-request", jsonRequest)
    },
    proceedState(nextState) {
      this.$emit("proceed-state", nextState)
    },
    proceedExecuter() {
      this.executerIndex += 1
    }
  },
  created() {
    var self = this
    this.socket.onmessage = function(event){
      console.log("Received")
      console.log(event)
      const res = JSON.parse(event.data)
      // self.$emit("show-text", {state: "assigning-mission", text: snackText})

      var textKey = ""
      var snackText = ""
      if (!res.data)return;
      if ('disclosure' in res.data) {
        textKey = "execute-disclosure"
        snackText += "情報開示により，"
        snackText += self.users.find(user => user.id == res.data.disclosure.userId).name
        if (res.data.disclosure.role == 'unknown') {
          snackText += "が ？<開示先プレイヤーのみ確認可能> であることが判明しました．"
        }else if (res.data.disclosure.role == 'resistance') {
          snackText += "が レジスタンス<開示先プレイヤーのみ確認可能> であることが判明しました．"
          // self.users.find(user => user.id == res.data.disclosure.userId).role = 'resistance'
          // self.$store.commit('setUsers', self.users)
        }else if (res.data.disclosure.role == 'spy') {
          snackText += "が スパイ<開示先プレイヤーのみ確認可能> であることが判明しました．"
          // self.users.find(user => user.id == res.data.disclosure.userId).role = 'spy'
          // self.$store.commit('setUsers', self.users)
        }
        self.$store.commit('deletePlot', {'userId': self.executer.id, 'plotId': 7})
        // self.$set(self.someObject, 'executerIndex', self.executerIndex + 1)
      }else if ('responsible' in res.data) {
        const plotId = res.data.responsible.sourceInfo.plotId

        textKey = "execute-responsibility"
        snackText += "責任者により，"
        snackText += self.users.find(user => user.id == res.data.responsible.destinationUserId).name
        snackText += "が"
        snackText += self.users.find(user => user.id == res.data.responsible.sourceInfo.userId).name
        snackText += "の"
        snackText += self.$store.getters.getPlotName(plotId)
        snackText += "を引き取りました．"

        self.$store.commit('deletePlot', {'userId': res.data.responsible.destinationUserId, 'plotId': 5})
        self.$store.commit('movePlot', {'sourceUserId': res.data.responsible.sourceInfo.userId, 'destinationUserId': res.data.responsible.destinationUserId, 'plotId': Number(plotId)})

        // self.$set(self.someObject, 'executerIndex', self.executerIndex + 1)
      }else if ('eavesdrop' in res.data) {
        console.log(res.data.eavesdrop)
        textKey = "execute-eavesdrop"
        snackText += "立ち聞きされた会話により，\""
        snackText += self.users.find(user => user.id == res.data.eavesdrop.userId).name
        if (res.data.eavesdrop.role == 'unknown') {
          snackText += "\"が ？<使用者のみ確認可能> であることが判明しました．"
        }else if (res.data.eavesdrop.role == 'resistance') {
          snackText += "\"が レジスタンス<使用者のみ確認可能> であることが判明しました．"
          // self.users.find(user => user.id == res.data.eavesdrop.userId).role = 'resistance'
          // self.$store.commit('setUsers', self.users)
        }else if (res.data.eavesdrop.role == 'spy') {
          snackText += "\"が スパイ<使用者のみ確認可能> であることが判明しました．"
          // self.users.find(user => user.id == res.data.eavesdrop.userId).role = 'spy'
          // self.$store.commit('setUsers', self.users)
        }
        self.$store.commit('deletePlot', {'userId': self.executer.id, 'plotId': 6})
        // self.$set(self.someObject, 'executerIndex', self.executerIndex + 1)
      }
      console.log(snackText)
      self.$emit("show-text", {state: textKey, text: snackText})

      var nextState = "assigning-mission"
      if (res.state == "assigning-mission"){
        nextState = "assigningMission"
        self.executerIndex = 0
        self.$emit("proceed-state", nextState)
      }else {
        nextState = "waitImmediateEffect"
      }
      self.$emit("proceed-state", nextState)
    }
  }
};
</script>

<style>
#waitImmediateEffect {
  /* background-color: rgb(253, 208, 208); */
}
#waitImmediateEffect .send-button{
  margin-bottom: 12px
  /* display: inline-block; */
}
#waitImmediateEffect .assigning-table {
 align-items: left;
 display: inline-block;
 text-align:center;
}
#waitImmediateEffect td {
  font-size: 16px;
  border-bottom-width: 0px;
  background-color: #F6F6FA;
}
#waitImmediateEffect .background-color {
  background-color: #F6F6FA;
}
#waitImmediateEffect .assign-button {
  margin-top: 4px;
  margin-bottom: 4px;
  background-color: #FFFFFF
}
#waitImmediateEffect .invalid-button {
  margin-top: 4px;
  margin-bottom: 4px;
  background-color: #F6F6FA
}
#waitImmediateEffect .plot-name {
  color: #5555BB;
  cursor:pointer;
}
</style>
